import Cookies from 'js-cookie';

const CACHE_KEY = 'cachedCartContent';
const CACHE_DURATION = 120000; // 2 minutes in milliseconds
const CART_COOKIE = Cookies.get('FE_CART_INFO');

export function getCachedCart() {
  const cookie_value = Object.fromEntries(
    CART_COOKIE?.split('&').map((pair) => pair.split(':')) || []
  );

  const cached = localStorage.getItem(CACHE_KEY);
  if (!cached) {
    return '';
  }

  const { data, expiryTime, cartCount } = JSON.parse(cached);
  const cacheExpired = new Date().getTime() > expiryTime;
  const cartMismatch = cartCount !== cookie_value.item_count;

  if (cacheExpired || cartMismatch) {
    return '';
  }
  
  return data;
}

export function setCachedCart(data:string) {
  if ((!data && data !== '') || window._be_platform === 'bifrost') {
    return;
  }

  const html = data;
  const tagMatch = html.match(/<span[^>]*data-cart-drawer-target="quantity"[^>]*>/);
  const cartCount = tagMatch ? tagMatch[0].match(/data-value="([^"]*)"/)?.[1] : null;
  const expiryTime = new Date().getTime() + CACHE_DURATION;

  localStorage.setItem(CACHE_KEY, JSON.stringify({ data, expiryTime, cartCount }));
}

export function clearCachedCart() {
  localStorage.removeItem(CACHE_KEY);
}